export default __webpack_public_path__ + "media/verification/title_locale_nb-9736ad67.png";